<div fxLayout="row" fxLayoutAlign="space-between center">
    <div></div>
    <p [innerHTML]=" customMessage| safeContent" class="message"></p>
    <i class="icon-cross" (click)="closeSnackbar()"></i>
</div>


